import React, { useState } from "react";
import PropTypes from "prop-types";

export const Search = ({ onSearch, className = "" }) => {
  const [query, setQuery] = useState("");

  const handleSearch = (e) => {
    const searchValue = e.target.value;
    setQuery(searchValue);
    onSearch(searchValue);
  };

  return (
    <input
      type="text"
      value={query}
      onChange={handleSearch}
      placeholder="Search by ID, Name, Email, Created By..."
      className={`w-full px-4 py-2 border rounded-md shadow-sm
                 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                 text-gray-900 bg-white placeholder-gray-500 ${className}`}
    />
  );
};

Search.propTypes = {
  onSearch: PropTypes.func.isRequired,
  className: PropTypes.string
};

export default Search;